import React from 'react';
import PropTypes from 'prop-types';
import { InputLabelsWrapper, InputRangeStyled, InputRangeWrapper } from './styles';
import { Input } from '../FormInput';
import { Heading, Label, Text } from '../../typography';

const InputRange = ({
  innerRef,
  name,
  value,
  min,
  max,
  values,
  onChange,
  step,
  defaultValue,
  rangeValue,
  style,
  noMargin,
  label,
  minLabel,
  maxLabel,
  hideInput,
  disabled,
  testid,
}) => {
  const val = values && name ? values[name] : value;

  return (
    <>
      {label && (
        <Heading htmlFor={label} type={5}>
          {label}
        </Heading>
      )}
      <InputRangeWrapper noMargin={noMargin} style={style}>
        {hideInput ? (
          <Text
            noMargin
            data-testid={`${testid}-text`}
            style={{ marginRight: 20, whiteSpace: 'nowrap', minWidth: 100 }}
          >
            {val}
          </Text>
        ) : (
          <Input
            name={name}
            data-testid={`${testid}-input-text`}
            ref={innerRef}
            value={val}
            disabled
          />
        )}
        <InputLabelsWrapper>
          <InputRangeStyled
            id={label}
            data-testid={`${testid}-range`}
            type="range"
            min={min}
            max={max}
            step={step}
            defaultValue={defaultValue}
            onChange={onChange}
            value={rangeValue}
            disabled={disabled}
          />
          <div>
            <Label small>{minLabel || Number(min).toLocaleString()}</Label>
            <Label small>{maxLabel || Number(max).toLocaleString()}</Label>
          </div>
        </InputLabelsWrapper>
      </InputRangeWrapper>
    </>
  );
};

InputRange.propTypes = {
  testid: PropTypes.string,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  label: PropTypes.string,
  innerRef: PropTypes.func,
  name: PropTypes.string,
  onChange: PropTypes.func,
  values: PropTypes.object,
  value: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  defaultValue: PropTypes.number,
  rangeValue: PropTypes.number,
  style: PropTypes.object,
  noMargin: PropTypes.bool,
  hideInput: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default InputRange;
